import store from "@/store";

export function resolveSyncTransport() {
	const latestVenueConfig = store.getters["user/latestVenueConfig"];
	return latestVenueConfig?.sse_enabled ? "sse" : "websocket";
}

export default resolveSyncTransport;
